import { library } from '@fortawesome/fontawesome-svg-core';
import { faLaptopHouse, faClinicMedical } from '@fortawesome/free-solid-svg-icons';

export const InitFontLibrary = () => {
    library.add(faLaptopHouse, faClinicMedical);
}
